// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"88f033be","55":"88f033be","208":"50498274","222":"88f033be","286":"88f033be","305":"88f033be","405":"634ccf28","512":"88f033be","609":"945286a9","793":"72367488","855":"88f033be","929":"88f033be","956":"88f033be"}[chunkId] + ".chunk.css";
};